import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import React from "react";

type Props = {
  data: Simplify<Content.EmergencySupportSliceDefaultPrimarySupportCardsItem>;
};

export default function EmergencySupportCard({ data }: Props) {
  return (
    <Card className="shadow-none border-secondary/50 flex flex-col h-full group hover:bg-primary transition-colors duration-300">
      <CardHeader>
        <CardTitle>
          <PrismicNextImage
            field={data.icon}
            alt=""
            className="size-12 [&_svg]:stroke-primary [&_svg]:group-hover:stroke-white [&_svg]:fill-primary [&_svg]:group-hover:fill-white group-hover:brightness-0 group-hover:invert transition-all duration-300"
          />
        </CardTitle>
      </CardHeader>

      <CardContent className="flex flex-col grow space-y-4">
        <h6 className="text-primary text-2xl font-semibold group-hover:text-white transition-colors duration-300">
          {data.title}
        </h6>

        <PrismicRichText
          field={data.description}
          components={{
            paragraph: ({ children }) => (
              <p className="text-primary text-lg font-merriweather group-hover:text-white transition-colors duration-300">
                {children}
              </p>
            ),
          }}
        />

        <Button
          asChild
          size="lg"
          className="rounded-full text-primary border-primary mt-auto self-start hover:bg-[#43D9BD] hover:text-white group-hover:bg-[#43D9BD] group-hover:text-white group-hover:border-[#43D9BD] transition-all! duration-300!"
          variant="outline"
        >
          <PrismicNextLink field={data.link} />
        </Button>
      </CardContent>
    </Card>
  );
}
